var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2219_5673)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    transform: "translate(0.556641)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.556641 2.22038C0.556641 0.993937 1.57577 0 2.8332 0H29.2801C30.5375 0 31.5566 0.993937 31.5566 2.22038V28.7796C31.5566 30.0061 30.5375 31 29.2801 31H2.8332C1.57577 31 0.556641 30.0061 0.556641 28.7796V2.22038ZM10.1337 25.9509V11.9524H5.48177V25.9509H10.1337ZM7.8087 10.0401C9.43039 10.0401 10.4398 8.96675 10.4398 7.62213C10.4108 6.24844 9.43233 5.20413 7.8397 5.20413C6.24708 5.20413 5.20664 6.25037 5.20664 7.62213C5.20664 8.96675 6.21608 10.0401 7.7777 10.0401H7.8087ZM17.318 25.9509V18.1331C17.318 17.7146 17.349 17.2961 17.473 16.9977C17.8081 16.1626 18.5735 15.2966 19.86 15.2966C21.5436 15.2966 22.216 16.5792 22.216 18.4624V25.9509H26.8679V17.9219C26.8679 13.6206 24.5739 11.6211 21.5126 11.6211C19.0443 11.6211 17.938 12.9774 17.318 13.9326V13.981H17.287C17.2972 13.9648 17.3076 13.9487 17.318 13.9326V11.9524H12.668C12.7261 13.2661 12.668 25.9509 12.668 25.9509H17.318Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2219_5673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(0.556641)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiLinkedin);
export default __webpack_public_path__ + "static/media/bi_linkedin.bff614d57c55fff71e94ebb7f4ff5bf7.svg";
export { ForwardRef as ReactComponent };